import React from "react";
import { LangItem } from "../core/Helpers/LangItem";
import { WowMainLine } from "./WowMainLine";
import { WowMainMedia } from "./WowMainMedia";

type MainCarouselProps = {
    photos: string[];
    videos?: string[];
    title?: string;
    description?: string;
    centeredTitle?: boolean;
    customStyle?: string;
};

type MainCarouselState = {
    selected: number;
    progress: number;
};

class MainCarousel extends React.Component<MainCarouselProps, MainCarouselState> {
    intervalTimeout = 6000;
    timerId: any = null;
    progressInterval: any = null;
    progressStartTime = 0;

    constructor(props: MainCarouselProps) {
        super(props);
        this.state = { selected: -1, progress: 0 };
    }

    componentDidMount() {
        setTimeout(() => this.changeIndex(0), 50);
    }

    componentWillUnmount() {
        this.clearTimers();
    }

    private clearTimers = () => {
        clearTimeout(this.timerId);
        clearInterval(this.progressInterval);
    };

    private getMediaList = () => {
        const { videos = [], photos } = this.props;
        return [
            ...videos.map((src) => ({ type: "video" as const, src })),
            ...photos.map((src) => ({ type: "photo" as const, src })),
        ];
    };

    private startPhotoTimer = () => {
        this.progressStartTime = Date.now();
        this.setState({ progress: 0 });

        this.progressInterval = setInterval(() => {
            const elapsed = Date.now() - this.progressStartTime;
            const progress = Math.min(elapsed / this.intervalTimeout, 1);
            this.setState({ progress });
            if (progress >= 1) this.next();
        }, 100);
    };

    private next = () => {
        const media = this.getMediaList();
        const nextIndex = (this.state.selected + 1) % media.length;
        this.changeIndex(nextIndex);
    };

    private changeIndex = (index: number) => {
        this.clearTimers();
        const media = this.getMediaList();
        const safeIndex = Math.max(0, Math.min(index, media.length - 1));
        const current = media[safeIndex];

        this.setState({ selected: safeIndex, progress: 0 }, () => {
            if (current.type === "photo") {
                this.startPhotoTimer();
            }
        });
    };

    private handleVideoProgress = (progress: number) => {
        this.setState({ progress });
    };

    render() {
        const { title, description, centeredTitle, customStyle } = this.props;
        const { selected, progress } = this.state;
        const media = this.getMediaList();

        return (
            <div className={`main-wow ${centeredTitle ? "centered-title" : ""} ${customStyle || ""}`}>
                <div className="main-wow-container">
                    <div className="main-wow-carousel">
                        {media.map((m, i) => (
                            <WowMainMedia
                                key={i}
                                media={m}
                                selected={i === selected}
                                onVideoEnded={this.next}
                                onProgress={this.handleVideoProgress}
                            />
                        ))}
                    </div>

                    <div className="main-wow-lines">
                        <div className="main-wow-lines-box">
                            {media.map((_, i) => (
                                <WowMainLine
                                    key={i}
                                    selected={i === selected}
                                    // progress={i === selected ? progress : i < selected ? 1 : 0}
                                    progress={i === selected ? progress :  0}
                                    myIndex={i}
                                    click={this.changeIndex}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="main-wow-text">
                        <div className="main-wow-sm-title">
                            <LangItem for={title || ""} />
                        </div>
                        <div className="main-wow-beauty-text">
                            <LangItem for={description || ""} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { MainCarousel };
